import type { ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { RootState } from '../../../store';
import { set } from '../../../store/Opportunity/PreliminaryProgram';

function PriliminaryProgram() {
  const dispatch = useDispatch();
  const opportunityPriliminaryProgram = useSelector((state: RootState) => state.opportunity.preliminaryProgram);
  const _projectType = [
    'Single Family',
    'Small Multi-Family',
    'Duplex',
    'Retail - Office',
    'Retail - Restaurant',
    'Retail - Medical',
    'Retail - Traditional',
    'Maintenance Facility',
    'Recreation Center',
    'Office',
    'School',
    'Mixed-Use',
  ];
  const _constructionType = ['New Construction', 'Renovation', 'Historic Renovation', 'Interior Fitout'];

  const changeHandler = (e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
    dispatch(set({ [e.target.name]: e.target.value }));
  };

  return (
    <>
      <h2 className='mt-0 text-primaryColor-normal'>Priliminary Program</h2>
      <div className='mb-4'>
        <label className='leading-7 text-sm text-gray-600'>
          Intended Use<sup>*</sup>
        </label>
        <input
          type='text'
          name='intendedUse'
          value={opportunityPriliminaryProgram.intendedUse}
          className='form-input'
          onChange={changeHandler}
        />
      </div>

      <div className='mb-4'>
        <label className='leading-7 text-sm text-gray-600'>
          NSRF<sup>*</sup>
        </label>

        <input type='text' name='nsrf' value={opportunityPriliminaryProgram.nsrf} className='form-input' onChange={changeHandler} />
      </div>

      <div className='mb-4'>
        <label className='leading-7 text-sm text-gray-600'>
          Gross Building Area<sup>*</sup>
        </label>
        <input
          type='text'
          name='grossBuildingArea'
          value={opportunityPriliminaryProgram.grossBuildingArea}
          className='form-input'
          onChange={changeHandler}
        />
      </div>

      <div className='mb-4'>
        <label className='leading-7 text-sm text-gray-600'>Parking Spaces</label>
        <input
          type='text'
          name='parkingSpaces'
          value={opportunityPriliminaryProgram.parkingSpaces}
          className='form-input'
          onChange={changeHandler}
        />
      </div>

      <div className='mb-4'>
        <label className='leading-7 text-sm text-gray-600'>Parking Location</label>
        <input
          type='text'
          name='parkingLocation'
          value={opportunityPriliminaryProgram.parkingLocation}
          className='form-input'
          onChange={changeHandler}
        />
      </div>
      <p className='mt-5 font-bold text-green-900'>+ Add Intended Use</p>
    </>
  );
}

export default PriliminaryProgram;
